import {
  CitizenshipStatus,
  VehicleType,
  UNIQUE_LINK_KEY,
  EMAIL_KEY,
} from '../../constants'
import { SupportedCountryCode, SSNStatus } from '../../models/types'
import { IDVStatus } from '../steps'
import { ApiResponseSlideType } from './api'
import SimpleStore from '../../utilities/SimpleStore'
import { get } from 'lodash'

type ApplicationSlideDeck = {
  body: string
  bodyImage: null | string
  subtitle: string
  title: string
  headerImage: string
  slideType: ApiResponseSlideType
  id: number
  market: null | string
}

type ApplicationDasherOrientation = {
  startingPoint: string
  startTime: string
  endTime: string
  id: number
  address: string
}

type ApplicationPhoneNumberComponents = {
  formattedNationalNumber: string
  nationalNumber: string
  formattedInternationalNumber: string
  countryCode: string
  internationalNumber: string
  countryShortname: string
}

export type Application = {
  uniqueLink: string
  mvReportResults: string
  phoneNumber: string
  lastName: string
  isPhoneScreened: boolean
  useVirtualOrientation: boolean
  mailingAddress: null | string
  citizenshipCountryShortname: null | string
  citizenshipStatus?: CitizenshipStatus
  submarket: number
  timezone: string
  isAtCapacityV2: boolean
  isOriented: boolean
  market: number
  firstName: string
  middleName: string
  identityTemplateId: null | string
  identityInquiryId: null | string
  signedDocumentsStatus: 'incomplete'
  isPhoneNumberVerified: boolean
  quiz: null
  completedProfileStep: boolean
  identityVerificationStatus: IDVStatus
  localOffices: undefined[]
  dateOfBirth: string
  middleNameExplicit: string
  hasConsumerAccount: boolean
  onlineOrientationCompletionStatus: string
  email: string
  isInstantDashingV2: boolean
  w9Signed: null
  backgroundCheckCompletionUrl: string
  needsBgCheckInfo: boolean
  currentOrientationSlideOrderId: number
  useDropshipping: boolean
  localOfficeAddress: boolean
  isDriverProfileCompleted: boolean
  vehicleType: VehicleType
  checkrCandidateCreated: boolean
  referredById: number | null
  backgroundCheckResults: string // TODO: 'skipped'
  hasDasherAccount: boolean
  hasAbn: boolean
  country: SupportedCountryCode
  isWEligible: boolean
  dasherId: number
  identityVerifiedAt: null
  orientationDate: string
  isVehicleInfoCompleted: boolean
  isGuarenteedEarnings: boolean
  slideDeck: {
    slides: ApplicationSlideDeck[]
    quizQuestions: number[]
    id: number
    name: string
    numSlides: number
  }
  ssnStatus?: SSNStatus
  dasherOrientation: ApplicationDasherOrientation
  phoneNumberComponents: ApplicationPhoneNumberComponents
}

export const DASHER_PLATFORM_INVALID_ARG_PREFIX = '3 INVALID_ARGUMENT: '
export const stripDasherPlatformErrorPrefix = (
  errorMessage: string | object
) => {
  let message = ''
  if (typeof errorMessage == 'object') {
    message = get(errorMessage, 'message', '')
  }
  if (typeof errorMessage == 'string') {
    if (!errorMessage.startsWith(DASHER_PLATFORM_INVALID_ARG_PREFIX)) {
      message = errorMessage
    }

    message = errorMessage
      .split(':')
      .slice(1)
      .join(':')
      .trim()
  }
  return message
}

export const setApplicantStore = ({
  uniqueLink,
  email,
}: {
  email: string
  uniqueLink: string
}): void => {
  SimpleStore.set(UNIQUE_LINK_KEY, uniqueLink)
  SimpleStore.set(EMAIL_KEY, email)
}
